// Network: abstract-testnet

// Network configuration
export const NETWORK = process.env.NEXT_PUBLIC_NETWORK || 'testnet';

// Contract addresses
export const LADDER_CONTRACT_ADDRESS = process.env.NETWORK === "mainnet" ? "0x0000000000000000000000000000000000000000" : "0x9c0813949441bc730ea64feb5a8c4431bcf2e3fb";
export const NOOT_TOKEN_ADDRESS = process.env.NETWORK === "mainnet" ? "0x0000000000000000000000000000000000000000" : "0x3d8b869eB751B63b7077A0A93D6b87a54e6C8f56";

//   NETWORK === 'mainnet'
// ? 'https://api.mainnet.abs.xyz'
// : 'https://api.testnet.abs.xyz'

export const RPC_URL = process.env.NETWORK === "mainnet" ? 'https://api.mainnet.abs.xyz' : 'https://api.testnet.abs.xyz';
export const WS_URL = process.env.NETWORK === "mainnet" ? 'wss://api.mainnet.abs.xyz/ws' : 'wss://api.testnet.abs.xyz/ws';

// Enumeration for card guesses
export const Guess = {
  Higher: 0,
  Lower: 1
};